var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 18.0476L11.6666 6.23808M24.9287 2.00732L39.6906 10.4423C40.5948 10.9588 41.3464 11.7052 41.869 12.6058C42.3916 13.5064 42.6668 14.5293 42.6666 15.5706V29.3818C42.6668 30.4231 42.3916 31.4459 41.869 32.3466C41.3464 33.2472 40.5948 33.9936 39.6906 34.5101L24.9287 42.945C24.0367 43.4546 23.0272 43.7226 22 43.7226C20.9727 43.7226 19.9632 43.4546 19.0712 42.945L4.30931 34.5101C3.40513 33.9936 2.65361 33.2472 2.13096 32.3466C1.60831 31.4459 1.33313 30.4231 1.33331 29.3818V15.5706C1.33313 14.5293 1.60831 13.5064 2.13096 12.6058C2.65361 11.7052 3.40513 10.9588 4.30931 10.4423L19.0712 2.00732C19.9632 1.4978 20.9727 1.2298 22 1.2298C23.0272 1.2298 24.0367 1.4978 24.9287 2.00732Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80951 13.619L19.2011 22.4467C20.0614 22.9097 21.023 23.1521 22 23.1521C22.9769 23.1521 23.9386 22.9097 24.7988 22.4467L41.1905 13.619M22 23.9524V43.1429",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssential);
export default __webpack_public_path__ + "static/media/essential.5ecf6f637c43d7d2aa1465b697af55e9.svg";
export { ForwardRef as ReactComponent };